import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1302Component } from './kymw1302.component';
import { GetPublishBillDataCSVService } from './api-services/get-publish-bill-data-csv.service';


/**
 * 掲載料請求データ出力画面 モジュール設定クラス
 *
 * @export KYMW1302Module
 * @class KYMW1302Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1302Component,
  ],
  providers: [
    GetPublishBillDataCSVService,
  ],
})
export class KYMW1302Module {
}
